/**
 * Renders baseline SEO tags from a route's `seo` config (see routeConfig.js).
 *
 * Mounted as an earlier sibling of the route's own component in App.js's
 * RouteRenderer. react-helmet-async gives priority to tags rendered later/
 * deeper in the tree, so any title/description/canonical/etc. the page
 * component sets itself (via its own <SEO> or <Helmet>) silently overrides
 * these defaults — this only fills gaps for routes that don't set their own.
 *
 * Canonical is intentionally omitted for dynamic (`:param`) and wildcard
 * (`*`) paths, since a literal `/insurance/:citySlug` canonical would be
 * wrong; pages on those routes are expected to set their own canonical.
 */
import React from "react";
import SEO from "../utils/seo/SEO";

const isStaticPath = (path) => Boolean(path) && !path.includes(":") && path !== "*";

const DefaultRouteSEO = ({ route }) => {
  if (!route?.seo) return null;

  const { title, description, keywords, robots } = route.seo;

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      robots={robots}
      canonical={isStaticPath(route.path) ? route.path : undefined}
    />
  );
};

export default DefaultRouteSEO;
